export const LINK = {
  ABSENTEE_FORM:
    'https://forms.office.com/Pages/ResponsePage.aspx?id=2FB9Kf3lC0-Dewb2YR188dM66eeNxBZHr61iOf4RoQBUNEFVWjI1WktITjZSUE1LRFQwNFFTQlFKSS4u',
};
